export default "__VITE_ASSET__aSFukoeb__"